import {t} from "i18next";

export const datePickerLocale = () => ({
    applyLabel: t('calendarPiker.action.apply'),
    cancelLabel: t('calendarPiker.action.cancel'),
    fromLabel: t('calendarPiker.calendar.from'),
    toLabel: t('calendarPiker.calendar.to'),
    customRangeLabel: t('calendarPiker.period')
})
